import { Download } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv'
import { type Headers } from 'react-csv/lib/core'

import { IconButton } from 'slab'
import { useGetPartnersPartnerIdPayoutsIdSummaryReport } from 'utils/web_api'
import { type PartnersPayoutSummary } from 'utils/web_api.schemas'

const headers: Headers = [
  { label: 'payout_date', key: 'payout_date' },
  { label: 'transaction_date', key: 'transaction_date' },
  { label: 'description', key: 'description' },
  { label: 'amount', key: 'amount' },
  { label: 'eligible_employees', key: 'employees' },
  { label: 'referral_rate', key: 'referral_rate' },
  { label: 'employer_id', key: 'employer_id' },
  { label: 'employer_name', key: 'employer_name' },
  { label: 'owner_email', key: 'assignee_email' },
]

const DownloadPayoutSummaryButton = ({
  partnerId,
  payoutId,
  payoutDate,
}: { partnerId: string; payoutId: string; payoutDate: string }) => {
  const csvLinkRef = useRef<CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }>(null)
  const [shouldFetch, setShouldFetch] = useState(false)
  const { data } = useGetPartnersPartnerIdPayoutsIdSummaryReport<PartnersPayoutSummary>(partnerId, payoutId, {
    query: { enabled: shouldFetch },
  })

  const items = data?.items

  // Transform data for CSV export - flatten money objects to formatted strings
  const csvData = items?.map((item) => ({
    ...item,
    amount: item.amount.formatted_amount,
    referral_rate: item.referral_rate?.formatted_amount ?? '',
  })) ?? []

  const onClick = () => {
    setShouldFetch(true)

    window.segment?.track('[TfB] Payout summary downloaded')
  }

  useEffect(() => {
    if (shouldFetch && items) {
      csvLinkRef.current?.link.click()
      setShouldFetch(false)
    }
  }, [shouldFetch, items])

  return (
    <>
      <IconButton
        onClick={onClick}
        icon={Download}
        label='Download Payout Summary'
      />
      <CSVLink
        ref={csvLinkRef}
        data={csvData}
        headers={headers}
        filename={`payout_summary_${payoutDate}.csv`}
        target='_blank'
        className='hidden'
      />
    </>
  )
}

export default DownloadPayoutSummaryButton
